export default {"src":"/_next/static/media/app-store_badge_fr.3803f8db.svg","height":40,"width":127,"blurWidth":0,"blurHeight":0};